import { useMemo, useState } from 'react';
import { PaginationHandle } from '../misc/Pagination/Pagination';

export function useArrayPagination<T>(
  items: Array<T>,
  pageSize: number
): { paginationHandle: PaginationHandle; currentPageItems: Array<T> } {
  const minPage = 1;
  const [page, setPage] = useState(minPage);

  const currentPageItems = useMemo<Array<T>>(() => {
    const zeroIndexedPage = page - 1;

    return items.slice(
      zeroIndexedPage * pageSize,
      (zeroIndexedPage + 1) * pageSize
    );
  }, [items, page, pageSize]);

  const maxPage = useMemo<number>(() => {
    return Math.max(Math.ceil(items.length / pageSize), 1);
  }, [pageSize, items]);

  return {
    paginationHandle: {
      minPage,
      maxPage,
      page,
      setPage
    },
    currentPageItems
  };
}
